import { selectedPropertyId } from '../state'

/**
 * Sets the selected Google Analytics property
 * @param {string} propertyId - The property ID to select
 */
export const selectProperty = (propertyId) => {
  selectedPropertyId.value = propertyId
}
